import ColorFormatter from '../../components/ColorFormatter';
import NumberFormatter from '../../components/Grid/NumberFormatter';
import CurrencyFormatter from '../../components/Grid/CurrencyFormatter';
import Summary from '../../components/Grid/Summary';
import CurrencySummary from '../../components/Grid/CurrencySummary';
import { DateFormatter } from '../../components/Grid/formatters/DateFormater';

export default [
	{
		key: 'statusColor',
		type: 'text',
		resizable: true,
		sortable: true,
		width: 20,
		formatter: ColorFormatter,
	},
	{
		key: 'statusDescription',
		name: 'Sit',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 65,
	},
	{
		key: 'salesOrder',
		name: 'Ped',
		type: 'number',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 50,
	},
	{
		key: 'deliveryDate',
		name: 'Ent',
		type: 'date',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 70,
		formatter: DateFormatter,
	},
	{
		key: 'customerName',
		name: 'Cliente',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		// width: 120,
	},
	{
		key: 'customerRegister',
		name: 'CNPJ',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 100,
	},
	{
		key: 'cityName',
		name: 'Cidade',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		// width: 100,
	},
	{
		key: 'stateCode',
		name: 'UF',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 50,
	},
	{
		key: 'priceTable',
		name: 'Tab. Preço',
		type: 'text',
		resizable: true,
		filterable: true,
		sortable: true,
		width: 200,
	},
	{
		key: 'sold',
		name: 'Qtde',
		type: 'number',
		formatter_index: 1,
		resizable: true,
		sortable: true,
		summary: Summary,
		width: 70,
		formatter: NumberFormatter,
	},
	{
		key: 'soldValue',
		name: 'Valor Total',
		type: 'number',
		resizable: true,
		sortable: true,
		width: 100,
		summary: CurrencySummary,
		formatter: CurrencyFormatter,
	},
	{
		key: 'invoicedValue',
		name: 'Valor Faturado',
		type: 'number',
		resizable: true,
		sortable: true,
		width: 100,
		summary: CurrencySummary,
		formatter: CurrencyFormatter,
	},
	{
		key: 'toBeInvoicedValue',
		name: 'Valor À Faturar',
		type: 'number',
		resizable: true,
		sortable: true,
		width: 100,
		summary: CurrencySummary,
		formatter: CurrencyFormatter,
	},
];
